import React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider as DefaultAuthProvider } from './lib/auth';

interface AppProvidersProps {
  queryClient: QueryClient;
  children: React.ReactNode;
  /**
   * Optional AuthProvider override. Defaults to the real AuthProvider from
   * `./lib/auth`. Round 4 SSG: Task 2 found Amplify Auth Node-safe so the
   * real one works at SSG too — main-ssg.tsx doesn't pass an override.
   * Preserved for future use if Amplify v6's Node behavior changes.
   */
  AuthProvider?: React.ComponentType<{ children: React.ReactNode }>;
}

/**
 * Shared provider chain used by both the runtime entry (main.tsx) and the
 * SSG entry (main-ssg.tsx). Extracted so a future provider addition only
 * needs to update one file. The provider chain MUST be identical across
 * entries — any divergence causes React 18 hydrateRoot to bail.
 */
export function AppProviders({
  queryClient,
  children,
  AuthProvider = DefaultAuthProvider,
}: AppProvidersProps): JSX.Element {
  return (
    <AuthProvider>
      <QueryClientProvider client={queryClient}>
        {children}
      </QueryClientProvider>
    </AuthProvider>
  );
}
